<template>
  <div class="t-notifications">
    <div class="t-lk-container">
      <link-back-cmp :btn="$root.staticText.lk.backMain" link-name="lk-main" class="t-lk-container-mobile"> </link-back-cmp>

      <div class="t-lk-title-link t-notifications__title t-lk-container-mobile">
        <h1 class="t-lk-title t-lk-title-link__title">{{ $root.staticText.lk.notifyAll }}</h1>
        <div @click="readNotify()" class="t-btn-green t-notifications__btn" :class="{ _disabled: countNew < 2 }">
          <template v-if="isMobile">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 11L12 14L22 4" stroke="#00b0bd" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16"
                stroke="#00b0bd"
                stroke-width="1.68"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </template>
          <template v-else>
            {{ $root.staticText.lk.notifyDelete }}
          </template>
        </div>
      </div>

      <lk-tags-cmp
        v-animation:bottom.delay
        v-if="tags.length > 0"
        class="t-notifications__filter"
        :tags="tags"
        :is-all="true"
        :all-name="$root.staticText.lk.notifyAll"
      >
      </lk-tags-cmp>

      <div v-if="pagination" v-animation:bottom.delay class="t-notifications__count t-lk-container-mobile">
        {{ pagination.totalCount }} {{ $root.num2str(pagination.totalCount, $root.staticText.lk.notifyNew) }}
      </div>

      <div class="t-notifications__container">
        <div class="t-notifications__left js-container-notify">
          <div
            v-animation:bottom.delay
            v-for="(item, index) in notifications"
            :key="'notify' + index"
            class="t-notifications__item"
            :class="{ _new: item.isNew }"
          >
            <div class="t-notifications__row">
              <div class="t-notifications__tag">{{ item.tag }}</div>
              <div class="t-notifications__date">
                {{ item.date }}
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.0007 3.16683C8.18834 3.16683 6.45025 3.88677 5.16875 5.16827C3.88726 6.44976 3.16732 8.18785 3.16732 10.0002C3.16732 10.8975 3.34407 11.7861 3.68747 12.6152C4.03088 13.4442 4.53422 14.1975 5.16875 14.8321C5.80329 15.4666 6.55659 15.9699 7.38565 16.3133C8.21471 16.6567 9.10328 16.8335 10.0007 16.8335C10.898 16.8335 11.7866 16.6567 12.6157 16.3133C13.4447 15.9699 14.198 15.4666 14.8325 14.8321C15.4671 14.1975 15.9704 13.4442 16.3138 12.6152C16.6572 11.7861 16.834 10.8975 16.834 10.0002C16.834 8.18785 16.114 6.44977 14.8325 5.16827C13.551 3.88677 11.813 3.16683 10.0007 3.16683ZM4.22595 4.22546C5.75749 2.69391 7.83472 1.8335 10.0007 1.8335C12.1666 1.8335 14.2438 2.69391 15.7754 4.22546C17.3069 5.757 18.1673 7.83423 18.1673 10.0002C18.1673 11.0726 17.9561 12.1346 17.5457 13.1254C17.1353 14.1162 16.5337 15.0165 15.7754 15.7749C15.017 16.5332 14.1167 17.1348 13.1259 17.5452C12.1351 17.9556 11.0731 18.1668 10.0007 18.1668C8.92819 18.1668 7.86623 17.9556 6.8754 17.5452C5.88458 17.1348 4.98429 16.5332 4.22595 15.7749C3.4676 15.0165 2.86605 14.1162 2.45563 13.1254C2.04522 12.1346 1.83398 11.0726 1.83398 10.0002C1.83398 7.83423 2.6944 5.757 4.22595 4.22546ZM10.0007 6.00016C10.3688 6.00016 10.6673 6.29864 10.6673 6.66683V9.72402L12.9721 12.0288C13.2324 12.2891 13.2324 12.7112 12.9721 12.9716C12.7117 13.2319 12.2896 13.2319 12.0292 12.9716L9.52925 10.4716C9.40422 10.3465 9.33398 10.177 9.33398 10.0002V6.66683C9.33398 6.29864 9.63246 6.00016 10.0007 6.00016Z"
                    fill="#C0C0CC"
                  />
                </svg>
              </div>
            </div>
            <div class="t-notifications__row">
              <div class="t-notifications__name">{{ item.name }}</div>
              <div v-if="item.isNew" class="t-notifications__eye" @click="readNotify(item.id.toString(), index)">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0.833984 10.0002C0.833984 10.0002 4.16732 4.3335 10.0007 4.3335C15.834 4.3335 19.1673 10.0002 19.1673 10.0002C19.1673 10.0002 15.834 15.6668 10.0007 15.6668C4.16732 15.6668 0.833984 10.0002 0.833984 10.0002Z"
                    stroke="#C0C0CC"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
                    stroke="#C0C0CC"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="t-notifications__delete" @click="deleteNotify(item.id.toString(), index)">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.33398 5.83333H16.6673M15.834 5.83333L15.1115 15.9517C15.0816 16.3722 14.8934 16.7657 14.5849 17.053C14.2764 17.3403 13.8705 17.5 13.449 17.5H6.55232C6.13077 17.5 5.72487 17.3403 5.41639 17.053C5.1079 16.7657 4.91975 16.3722 4.88982 15.9517L4.16732 5.83333H15.834ZM8.33398 9.16667V14.1667V9.16667ZM11.6673 9.16667V14.1667V9.16667ZM12.5007 5.83333V3.33333C12.5007 3.11232 12.4129 2.90036 12.2566 2.74408C12.1003 2.5878 11.8883 2.5 11.6673 2.5H8.33398C8.11297 2.5 7.90101 2.5878 7.74473 2.74408C7.58845 2.90036 7.50065 3.11232 7.50065 3.33333V5.83333H12.5007Z"
                    stroke="#C0C0CC"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>

          <load-more-cmp
            v-if="pagination"
            :pagination="pagination"
            :btn="$root.staticText.lk.loadMore"
            class="t-faq__more"
            :disabled-btn="disableLoadMore"
          >
          </load-more-cmp>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import linkBack from '@components/lk/link-back/link-back.vue'
import loadMore from '@components/ui-components/load-more/load-more.vue'
import titleLink from '@components/lk/lk-title-link/lk-title-link.vue'
import lkTags from '@components/lk/lk-tags/lk-tags'
import onScrollAnimate from '@assets/js/scrollAnimate.js'
import { mapMutations, mapState } from 'vuex'
import { router } from '@src/routes'

export default {
  name: 'lk-faq',
  data() {
    return {
      notifications: null,
      tags: [],
      pagination: null,
      countNew: 0,
      disableLoadMore: false,
    }
  },
  components: {
    'link-back-cmp': linkBack,
    'load-more-cmp': loadMore,
    'lk-title-link-cmp': titleLink,
    'lk-tags-cmp': lkTags,
  },
  computed: {
    ...mapState('mobile', ['isMobile', 'isTablet']),
  },
  methods: {
    ...mapMutations('lk', ['deleteProfileNotify']),

    setData(data) {
      this.notifications = data.items
      this.tags = data.tags
      this.pagination = data.pagination

      this.updateCountNew()
    },
    updateCountNew() {
      this.countNew = this.notifications.filter(item => item.isNew).length
    },
    /**
     * @param {string} id
     * @param {number} index
     */
    readNotify(id, index) {
      let fd = new FormData()
      if (id) {
        fd.append('id', id)
      }

      Vue.http
        .post('lk/readNotify', fd)
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            if (id) {
              this.notifications[index].isNew = false
              this.deleteProfileNotify(id)
            } else {
              this.notifications.forEach(item => {
                item.isNew = false
              })
              this.deleteProfileNotify()
            }
            this.updateCountNew()
          }
        })
        .catch(() => {})
    },
    /**
     * @param {string} id
     * @param {number} index
     */
    deleteNotify(id, index) {
      let fd = new FormData()
      if (id) {
        fd.append('id', id)
      }

      Vue.http
        .post('lk/deleteNotify', fd)
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            if (id) {
              this.notifications.splice(index, 1)
              this.deleteProfileNotify(id)
            } else {
              this.notifications = []
              this.deleteProfileNotify()
            }
            this.updateCountNew()
          }
        })
        .catch(() => {})
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (to.query.loadMore) {
      this.disableLoadMore = true
      let url = process.env.NODE_ENV !== 'production' ? 'lk/notifications.json' : to.path.substring(1).replace(router.history.base, '')

      Vue.http.get(url, { params: to.query }).then(
        data => {
          next()
          this.notifications = this.notifications.concat(data.data.items)
          this.pagination = data.data.pagination
          this.disableLoadMore = false
        },
        () => {
          this.disableLoadMore = false
          next('/404')
        }
      )
    } else {
      this.$root.setDataAnimateFalse('.js-container-notify ')

      let url = process.env.NODE_ENV !== 'production' ? 'lk/notifications.json' : to.path.substring(1).replace(router.history.base, '')

      Vue.http.get(url, { params: to.query }).then(
        data => {
          setTimeout(() => {
            this.notifications = data.data.items
            this.pagination = data.data.pagination
            onScrollAnimate()
          }, 500)
          next()
        },
        () => {
          next('/404')
        }
      )
    }
  },
  beforeRouteEnter(to, from, next) {
    let url = process.env.NODE_ENV !== 'production' ? 'lk/notifications.json' : to.path.substring(1).replace(router.history.base, '')

    Vue.http.get(url).then(
      data => {
        next(vm => vm.setData(data.data))
      },
      data => {
        if (data.status === 403) {
          next({ name: 'E403' })
        } else {
          next({ name: 'E404' })
        }
      }
    )
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/pages/lk/notifications/index.vue